module.exports = __webpack_public_path__ + "media/images/web/home/index/cultural-bcfd30dbf6b82f471ae7225d4ccf3b94.jpg";